import api from "./api";

export const forgotPassword = async (email) => {
  const response = await api.post("/auth/forgot-password", { email });
  return response.data; // Return the full response to get the message
};

export const resetPassword = async ({ email, token, password }) => {
  const response = await api.patch(`/auth/reset-password?email=${email}&token=${token}`, {
    password,
  });
  return response.data;
};

